import { render, staticRenderFns } from "./SplashScreen.vue?vue&type=template&id=a8952ca6&scoped=true"
import script from "./SplashScreen.vue?vue&type=script&lang=js"
export * from "./SplashScreen.vue?vue&type=script&lang=js"
import style0 from "./SplashScreen.vue?vue&type=style&index=0&id=a8952ca6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8952ca6",
  null
  
)

export default component.exports